import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { VariantService } from '@core/services/variant/variant.service';

@Injectable({
	providedIn: 'root',
})
export class ShopGuard implements CanActivate {
	constructor(
		private variantService: VariantService,
		private router: Router,
	) {}

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (!this.variantService.isShop()) {
			return this.router.createUrlTree(['/home'], { queryParams: route.queryParams });
		}
		return true;
	}
}
